
import * as React from "react";
import { Collapse, Row, Button,  Tag, Tabs, 
    InputNumber, Typography, Col, Table, Select, Pagination, Divider, Input } from 'antd';
import ReactECharts from 'echarts-for-react';
import { extract_dataset_list, extract_api_list, 
    extract_task_list, extract_explore_dataset_list,
    extract_fairness_from_data, extract_value_from_data,
    convert_package_to_graph,
    extract_ps_data_from_package,
    extract_rawdata_for_imagedisplay} from "../../../helper/preprocessor";
import AccuracyD3Chart from "./AccuracyD3Chart";
import AccuracyChart from "./AccuracyChart";
import ConsistencyChart from "./ConsistencyChart";
import ConfidenceChart from "./ConfidenceChart";
import FairnessChart from "./FairnessChart";
import { assert } from "console";
import { assert_key, getLineColor, skew_weight, 
    safe_extract_item_from_list, safe_extract_items_from_list,
     get_mode_options, 
     assert_key_hier,
     getDecimal} from "../../../helper";
import PCPChart from "./PCPChart";
import { off } from "process";
import ParallelCoordinates from "./ParallelSets";
import ImageDisplay from "./ImageDisplay";


    
// render echarts option.
const d3 = require("d3");
const { Search } = Input;
console.log("d3:", d3.version)
export interface IProps {
    api_id: number | null, // dummy
    api_id_list:any, 
    dataset_id: number | null,
    task_id: number | null,
    mode_id: number,
    data:any,
    explore_meta_data: any,
    explore_refresh_number: number,
    explore_loading: boolean,
    width: any,
    height: any
}
export interface IState {
    filters: any,
    search_input:string
}

export default class InfoView extends React.Component<IProps, IState>{
    constructor(props:IProps) {
        super(props);
        this.renderInfoContent = this.renderInfoContent.bind(this);
        this.changeFilters = this.changeFilters.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.state = {
            filters: {},
            search_input: ""
        }
        // Flow:
        // 1. Constructor
        // 2. componentWillMount()
        // 3. render()
        // 4. componentDidMount()
        // If props update:
        // 4.1 componentWillReceiveProps(nextProps : IProps), then goto 5.
        // If States update
        // 5. shouldComponentUpdate() if return false, then no rerendering.
        // 6. if True, then componentWillUpdate
        // 7. render()
        // 8. componentDidUpdate
        // If Unmount, then componentWillUnmount()
    }
    public changeFilters(filters: any){
        this.setState({
            filters: filters
        })
    }
    public onSearch(search_input: string){
        this.setState({
            search_input: search_input
        })
    } 

    public renderInfoContent(){
        let {dataset_id, api_id, data, task_id, api_id_list, mode_id} = this.props;
        
        // If selected dataset and api, then it can be displayed, 
        // otherwise it cannot be displayed.
        
        // 1. Extract selected dataset name and selected api name
        let task_list = extract_task_list(data);
        let dataset_list = extract_dataset_list(data, task_id);
        let api_list = extract_api_list(data, task_id);
        let mode_list = get_mode_options();
        
        let selected_task_name = safe_extract_item_from_list(task_id, task_list);
        let selected_dataset_name = safe_extract_item_from_list(dataset_id, dataset_list);
        let selected_api_name_list = safe_extract_items_from_list(api_id_list, api_list);
        let selected_mode_name = safe_extract_item_from_list(mode_id, mode_list);

        
        
        function generateFairnessChart(fairness_pkg:any, col_size:any){
            return <Col span={col_size}><FairnessChart fairness_package={fairness_pkg}/></Col>
        }
        function generatePureFairnessChart(fairness_pkg:any){
            return <Row>
                <Col span={24}>
                <Divider>Fairness</Divider>
                    <FairnessChart fairness_package={fairness_pkg}/>
                    </Col>
                    </Row>
        }
        let generateMetricsVisualization = () => {
            let subdata = {};
            let decimal = getDecimal();
            if(Object.keys(data).indexOf(selected_task_name)>=0){
                subdata = data[selected_task_name];
            }
            if(selected_api_name_list.length > 1){
                let acc_package_dict:any = {};
                for(let i = 0; i<selected_api_name_list.length; i++){
                    let selected_api_name = selected_api_name_list[i];
                    let acc_package = extract_value_from_data(subdata, "AccuracyTable", selected_dataset_name, selected_api_name);
                    acc_package_dict[selected_api_name] = acc_package;
                }
                return <div>
                {/*API: {selected_api_name} and Dataset: {selected_dataset_name}*/}
                <div style={{"width":"100%", "height":"100%"}}>
                    <Row>
                        <Col span={24}>
                        {/*<AccuracyD3Chart acc_package={acc_package}
                        name={"Accuracy"}
                        width={this.props.width / 3}
        height={"400"}/>*/}
                        <Divider>Accuracy</Divider>
                        <AccuracyChart acc_package={acc_package_dict} />

                        </Col>
                        
                    </Row>

                </div>

            </div>
            }else if(selected_api_name_list.length === 1){
                let selected_api_name = selected_api_name_list[0];
                
                let acc_package = extract_value_from_data(subdata, "AccuracyTable", selected_dataset_name, selected_api_name);
                let acc_package_dict:any = {};
                acc_package_dict[selected_api_name] = acc_package;
                let consistency_raw_package = extract_value_from_data(subdata, "ConsistencyTable", selected_dataset_name, selected_api_name);
                let confidence_raw_package = extract_value_from_data(subdata, "ConfidenceTable", selected_dataset_name, selected_api_name);
                let consis_graph_pkg = convert_package_to_graph(consistency_raw_package);
                let conf_graph_pkg = convert_package_to_graph(confidence_raw_package);
                let col_size = 8;
                let fairness_pkg = extract_fairness_from_data(subdata, "FairnessTable", selected_dataset_name, selected_api_name);
                console.log("fairness_pkg", fairness_pkg)
                let enable_fairness = Object.keys(fairness_pkg).length>0;
                if(enable_fairness){
                    col_size = 6;
                }

                
                let generate_horizontal_layout = () => {
                    return <Row>
                        <Col span={col_size}>
                        {/*<AccuracyD3Chart acc_package={acc_package}
                        name={"Accuracy"}
                        width={this.props.width / 3}
        height={"400"}/>*/}
                        <AccuracyChart acc_package={acc_package_dict} />

                        </Col>
                        <Col span={col_size}>
                        <ConsistencyChart consistency_package={consis_graph_pkg}/>

                        </Col>
                        <Col span={col_size}>
                        <ConfidenceChart confidence_package={conf_graph_pkg}/>

                        </Col>
                        {(enable_fairness)?(generateFairnessChart(fairness_pkg, col_size)):<div/>}
                    </Row>
                }
                let generate_veritical_layout = () => {
                    return <Row>
                        <Col span={24}>

                        
                    <Row>
                    {/*<AccuracyD3Chart acc_package={acc_package}
                    name={"Accuracy"}
                    width={this.props.width / 3}
    height={"400"}/>*/}
                    <Col span={24}>
                    <Divider>Accuracy</Divider>
                    <AccuracyChart acc_package={acc_package_dict} />
                    </Col>
                    </Row>
                    <Row>
                    <Col span={24}>
                    <Divider>Consistency</Divider>
                    <ConsistencyChart consistency_package={consis_graph_pkg}/>
                    </Col>
                    </Row>
                    <Row>
                    <Col span={24}>
                    <Divider>Confidence</Divider>
                    <ConfidenceChart confidence_package={conf_graph_pkg}/>
                    </Col>
                    </Row>
                    {(enable_fairness)?(generatePureFairnessChart(fairness_pkg)):<div/>}
                    </Col>
                </Row>
                }
                let generate_layout = (width:any)=>{
                    return generate_veritical_layout();
                    /*if(width >= 1000){
                        return generate_horizontal_layout();
                    }else{
                        return generate_veritical_layout();
                    }*/
                }
                return <div>
                    {/*API: {selected_api_name} and Dataset: {selected_dataset_name}*/}
                    <div style={{"width":"100%", "height":"100%"}}>
                        
                    {generate_layout(this.props.width)}
                    </div>

                </div>
            }
        }
        let generateExploreVisualization = () => {
            if(this.props.explore_loading === true){
                return  <div>Loading...</div>
            }
            if(selected_api_name_list.length === 1){
                
                let selected_api_name = selected_api_name_list[0];
                let ps_package = extract_ps_data_from_package(this.props.explore_meta_data, 
                    selected_dataset_name,
                     selected_api_name,
                     selected_task_name);
                let ps_package_spec = [{
                    "n":"PSJson",
                    "c":[{
                        "n":"PSData"
                    },{
                        "n":"name"
                    }]
                },{
                    "n":"PSDimensions"
                },{
                    "n":"ReversedDimMapping"
                }]
                let flag = assert_key_hier(ps_package, ps_package_spec);
                if(!flag){
                    return <div>Data unavailable.</div>
                    // return <div />;
                }
                let PSJson = ps_package["PSJson"];
                let PSDimensions = ps_package["PSDimensions"];
                let ReversedDimMapping = ps_package["ReversedDimMapping"];
                let row_image_num = 4;
                let image_width = 200;
                let image_height = 200;
                let image_container_width = this.props.width - 40;
                row_image_num = Math.min(Math.floor(image_container_width / (image_width)), row_image_num);
                row_image_num = Math.max(row_image_num, 1);
                image_width = Math.min(image_container_width / row_image_num - 10, image_width);
                image_width = Math.max(image_width, 10);
                image_height = image_width;

                let parallel_sets_height = 400;
                parallel_sets_height = Math.min(this.props.height - 40, parallel_sets_height);
                parallel_sets_height = Math.max(parallel_sets_height, 40);
                let parallel_sets_width = this.props.width - 60;
                parallel_sets_width = Math.max(parallel_sets_width, 40);

                let rawdata_list = extract_rawdata_for_imagedisplay(ps_package, selected_dataset_name, this.state.filters, this.state.search_input);


                return <div style={{"width":"100%", "height":"100%"}}>
                    <Row>
                        <Col span={24}>
                        <Divider>Confidence Parallel Sets</Divider>
                            <ParallelCoordinates 
                                PSJson={PSJson}
                                PSDimensions={PSDimensions}
                                ReversedDimMapping={ReversedDimMapping}
                                width={parallel_sets_width}
                                height={parallel_sets_height}
                                changeFilters={this.changeFilters}
                                >
                                
                            </ParallelCoordinates>
                            <Divider>Instances</Divider>
                            <Search placeholder="Search instances with ground truth label." defaultValue={this.state.search_input} onSearch={this.onSearch} style={{ width: "100%" }} />
                            <br />
                            <br />
                            <br />
                            <ImageDisplay rawdata_list={rawdata_list} image_width={image_width}
                                        image_height={image_height} row_image_num={row_image_num}
                                        task_name={selected_task_name}
                            />
                        </Col>
                    </Row>

                </div>

                /*
                let pcp_package = extract_pcp_data_from_package(this.props.explore_meta_data, selected_dataset_name, selected_api_name);
                return <div style={{"width":"100%", "height":"100%"}}>
                    <Row>
                        <Col span={8}>
                            <PCPChart pcp_package={pcp_package}></PCPChart>
                        </Col>
                        
                    </Row>

                </div>
                */
            }else{
                return <div>Please select one API.</div>
            }
            
        }
        if(selected_api_name_list && selected_dataset_name && selected_task_name){
            if(selected_mode_name == "Metrics"){
                return generateMetricsVisualization();
            }else if(selected_mode_name == "Explore"){
                return generateExploreVisualization();
            }
            
            
            
        }
        
        return <div />
    }

    public render() {
        console.log("InfoView Props:", this.props);
        let {dataset_id, api_id, data, mode_id} = this.props;
        let viewtitle = "Statistics";
        if(mode_id === 2){
            viewtitle = "Explore";
        }
        //height:""+(this.props.height - 40)+"px",
        return (            
            <div>
                <div className="ViewTitle2">{viewtitle}</div>
                
                <div className="ViewBox">
                    <div style={{width: "100%",   overflowY: "hidden"}}>
                        {this.renderInfoContent()}

                    </div>
                </div>
            </div>
        )
    }
}